module.exports = __webpack_public_path__ + "static/media/speaker_AWS_DrPark.6e46ab11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_AWS_DrPark.jpg
// module id = 237
// module chunks = 0